import {
  Badge as AntdBadge,
  BadgeProps as AntdBadgeProps,
} from "@timeedit/ui-components/antd";

type BadgeProps = AntdBadgeProps;

export function Badge(props: BadgeProps): React.JSX.Element {
  return <AntdBadge overflowCount={100000} {...props} />;
}
